import { Component, OnInit } from '@angular/core';
import { ContactService } from '../_services/contact.service';
import { TranslateService } from 'ngx-translate-with-country';
import { Title } from '@angular/platform-browser';
import { appsettings } from '../shared/app.settings';
declare var $: any;

@Component({
  selector: 'app-wheretobuy',
  templateUrl: './wheretobuy.component.html',
  styleUrls: ['./wheretobuy.component.scss']
})
export class WheretobuyComponent implements OnInit {

  contactLink :any;

  constructor(
    private _contactService: ContactService,
    private translate: TranslateService,
    public titleService: Title
  ) { }

  ngOnInit() {
    $(document).foundation();
    this._contactService.getContact()
    .subscribe(resFeaturedData => this.contactLink = resFeaturedData);

    this.translate.get(['WHERETOBUY'])
    .subscribe(
      translations => {
        this.titleService.setTitle(translations.WHERETOBUY + ' - ' + appsettings.siteTitle);
        // console.log(this.sendTitle('About Us'));
      })
  }
 
}
